export default function LocationAdvantagePathway() {
  return <div>LocationAdvantagePathway</div>;
}
